import { Fragment } from "preact";
import Center from "../../../../components/center";
import Editorial from "../../../../components/editorial";
import Head from "../../../../components/head";
import Hero from "../../../../components/hero";
import Ligature from "../../../../components/ligature";
import CandidateBio from "../../../../components/candidate-bio";
import namedRoutes from "../../../../settings/routes";

const candidate = {
  name: "Jim Cline",
  since: 2008,
  email: "undihrs@gmail.com",
  photo: "/images/candidates/jim-cline.jpg",
};

const pageTitle = `2025 - ${candidate.name} - Klahanie.info`;

const questions = null;

const JimCline = () => (
  <Editorial>
    <Head title={pageTitle} />
    <Hero background="/images/backgrounds/forest-path.jpg">
      <h1>
        <span style="font-size: 0.5em; font-weight: 400; display: block; margin-bottom: 0.25em; text-transform: none;">
          Vote for{" "}
        </span>
        <Ligature>{candidate.name}</Ligature>
      </h1>
      <h2 style="font-size: 1.1em; font-weight: 400;">
        <span>Klahanie resident since {candidate.since}</span>
      </h2>
    </Hero>
    <div>
      <Center>
        <CandidateBio
          img={candidate.photo}
          name={candidate.name}
          since={candidate.since}
          email={candidate.email}
          questions={questions}
          links={[
            {
              text: "Jim's HOA Letter",
              href: namedRoutes.archive2025.jimClineHoaLetter,
            },
          ]}
        >
          <Fragment>
            <p>
              The pending proposal for a $12.5 million community center has
              attracted strong owner interest. I am committed to working with
              Klahanie residents to ensure that, on this and other projects, we
              have a HOA Board that functions in a democratic and transparent
              manner, furthering the interests of the entire community.
            </p>
            <p>
              I have 38 years of experience as a practicing attorney. I have
              extensive professional and volunteer experience in nonprofit
              boards, the public sector and laws and operations involving both.
              I served 3 ½ years as a King County Deputy Prosecutor and nearly
              35 years as a labor law attorney.
            </p>
            <p>
              Most of my labor work has been on behalf of public safety labor
              organizations, especially, police, fire and other first
              responders. These labor unions are operated as member led
              organizations and in my capacity as labor attorney, I have
              provided legal advice to nearly 100 such boards. I have also
              served in a range of board and leadership capacities including a
              school commission, a church council, a nonprofit domestic violence
              organization, and a range of political organizations, including a
              national political organization.
            </p>
            <p>
              For the past 4 years I have served on the Board and Treasurer for
              our recreational property HOA in Sunriver. In that role, I’ve
              developed an understanding of the importance and requirements of
              proper budgeting and reserve standards. I understand the role and
              responsibilities of Board members and those include good
              governance and transparent processes.
            </p>
            <p>
              I am committed to ensuring that any large capital project be fully
              vetted and any requirement of taking on significant debt be
              approved by owners. We all want a community that respects the
              varied opinions of its members and my commitment as a Board member
              is to ensure that occurs. I will also bring to the Board my
              extensive experience and knowledge regarding board operations and
              budgeting procedures to develop a capital funding plan that is
              practical and prudent.
            </p>
          </Fragment>
        </CandidateBio>
      </Center>
    </div>
  </Editorial>
);

export default JimCline;
